import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Build version injected at compile time — forces unique bundle hash on each deployment.
// This ensures the service worker always detects a new version and users never
// see stale cached code after a deployment.
window.__OKBOT_BUILD__ = process.env.REACT_APP_BUILD_VERSION || "dev";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
